module.exports = __webpack_public_path__ + "img/cos.1a21ee2e.jpg";